var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 20,
    viewBox: "0 0 60 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 20,
    rx: 3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 5L21.2 15H18.5L16.8 7.8C16.7 7.4 16.6 7.2 16.3 7C15.8 6.7 15 6.4 14.3 6.2L14.4 5H19.2C19.8 5 20.3 5.4 20.4 6.1L21.3 11.5L23.7 5H26.4L24.5 5ZM38.5 11.8C38.5 9.2 35.1 9.1 35.1 7.9C35.1 7.5 35.5 7.1 36.3 7C36.7 6.9 37.7 6.8 38.8 7.3L39.3 5.4C38.7 5.2 37.9 5 36.9 5C34.4 5 32.6 6.3 32.6 8.2C32.6 9.6 33.9 10.4 34.9 10.9C35.9 11.4 36.2 11.7 36.2 12.1C36.2 12.7 35.5 13 34.8 13C33.6 13 33 12.8 32 12.3L31.5 14.3C32.5 14.7 33.4 15 34.8 15C37.5 15 39.3 13.7 39.3 11.7L38.5 11.8ZM45.5 15H47.8L45.8 5H43.7C43.2 5 42.8 5.3 42.6 5.7L38.8 15H41.5L42 13.5H45.2L45.5 15ZM42.7 11.5L43.9 8L44.7 11.5H42.7ZM31.5 5L29.4 15H26.9L29 5H31.5Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.98f51b8465c5ec94067c7c4d573fbde3.svg";
export { ForwardRef as ReactComponent };